import { useMemo } from "react";
import { Field, Select, TextInput } from "../ui/controls";

// Common refrains for the prière universelle (the assembly's response after each
// intention), curated from French parish/liturgy usage. Free text is still allowed.
export const PU_REFRAINS: string[] = [
  "Accueille au creux de tes mains la prière de tes enfants.",
  "Seigneur, écoute-nous, Seigneur, exauce-nous.",
  "Seigneur, entends notre prière.",
  "Nous te prions, Seigneur.",
  "Ô Seigneur, écoute et prends pitié.",
  "Seigneur, écoute et prends pitié.",
  "Ô Christ, écoute-nous, ô Christ, exauce-nous.",
  "Seigneur, entends la prière qui monte de nos cœurs.",
  "Notre Père, notre Père, nous te supplions humblement.",
  "Entends nos prières, entends nos voix, entends nos prières monter vers toi.",
  "Toi qui nous aimes, écoute-nous, Seigneur.",
  "Dieu de tendresse, souviens-toi de nous.",
  "Ô Christ ressuscité, exauce-nous.",
  "Sur la terre des hommes, fais briller, Seigneur, ton amour.",
  "Jésus, sauveur du monde, écoute et prends pitié.",
  "Ô Seigneur, envoie ton Esprit qui renouvelle la face de la terre.",
  "Sûrs de ton amour et forts de notre foi, Seigneur, nous te prions.",
  "Fais paraître ton jour, que l'homme soit sauvé.",
];

const FREE = "__free__";

export function IntentionRefrainPicker({
  value,
  onChange,
  hint,
}: {
  value: string;
  onChange: (v: string) => void;
  hint?: string;
}) {
  // Keep the current value selectable even if it isn't one of the presets.
  const known = useMemo(() => {
    const seen = new Set<string>();
    const list: string[] = [];
    for (const r of PU_REFRAINS) {
      const k = r.trim();
      if (k && !seen.has(k.toLowerCase())) { seen.add(k.toLowerCase()); list.push(k); }
    }
    return list;
  }, []);

  const isKnown = known.includes(value);

  return (
    <Field label="Refrain" hint={hint}>
      <Select value={isKnown ? value : FREE} onChange={(v) => onChange(v === FREE ? "" : v)}>
        {known.map((r) => (
          <option key={r} value={r}>{r}</option>
        ))}
        <option value={FREE}>✎ Autre (saisir un refrain)…</option>
      </Select>
      {!isKnown && (
        <div style={{ marginTop: 8 }}>
          <TextInput value={value} placeholder="Refrain de la prière universelle" onChange={onChange} />
        </div>
      )}
    </Field>
  );
}
